<template>
  <div
    ref="liveAnnouncer"
    :role="role"
    :aria-live="politeness"
    class="sr-only"
  ></div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps<{
  role: "status" | "alert";
  politeness: "off" | "polite" | "assertive";
}>();

const liveAnnouncer = ref<HTMLElement | null>(null);

defineExpose({
  element: liveAnnouncer,
});
</script>
